import { ClickableCellRenderer } from '../../../../../components/AGGrid/cell-renderers/clickable';
import moment from 'moment/moment';
import { DownloadCellRenderer } from '../../../../../components/AGGrid/cell-renderers/download';
import { CMActionButtonsRenderer } from '../../../../../components/AGGrid/cell-renderers/cm-multi-clickable';
import { IconCellRenderer } from '../../../../../components/AGGrid/cell-renderers/icon';
import {CustomHeader} from "../../../../../components/AGGrid/cell-renderers/custom-header";

export const id = {
    field: 'id',
    headerName: 'ID',
    flex: 2,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'id',
        page: 'titles',
    }
};

export const title = {
    field: 'title',
    headerName: 'Title',
    tooltipField: 'title',
    flex: 5,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'title',
        page: 'titles',
    }
};

export const type = {
    field: 'productType',
    headerName: 'Type',
    flex: 2,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'productType',
        page: 'titles',
    }
};

export const status = {
    field: 'lifeCycleStatus',
    headerName: 'Status',
    flex: 2,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'lifeCycleStatus',
        page: 'titles',
    }
};

export const imported = {
    headerName: 'Imported',
    cellRenderer: IconCellRenderer(),
    flex: 2,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'clearanceMemoImported',
        page: 'titles',
    }
};

export const foxWprId = {
    field: 'foxFinancialTitleId',
    headerName: 'FOX WPR ID',
    flex: 2,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'foxFinancialTitleId',
        page: 'titles',
    }
};

export const foxId = {
    field: 'foxipediaId',
    headerName: 'FOX ID',
    flex: 2,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'foxipediaId',
        page: 'titles',
    }
};

export const productId = {
    field: 'mappedProductId',
    headerName: 'Product ID',
    flex: 2,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'mappedProductId',
        page: 'titles',
    }
};

// DATE COMPARATOR FOR SORTING
function dateComparator(date1, date2) {
  var date1Number = _monthToNum(date1);
  var date2Number = _monthToNum(date2);

  if (date1Number === null && date2Number === null) {
    return 0;
  }
  if (date1Number === null) {
    return -1;
  }
  if (date2Number === null) {
    return 1;
  }

  return date1Number - date2Number;
}

// HELPER FOR DATE COMPARISON
function _monthToNum(date) {
  if (date === undefined || date === null || date.length !== 10) {
    return null;
  }

  var yearNumber = date.substring(6, 10);
  var monthNumber = date.substring(3, 5);
  var dayNumber = date.substring(0, 2);

  var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
  // 29/08/2004 => 20040829
  return result;
}

export const releaseDate = {
    headerName: 'Release Date',
    flex: 2,
    comparator: dateComparator,
    valueGetter: (data) => {
        return data?.data.releaseDate && moment(data.data.releaseDate).format('MM/DD/YYYY');
    },
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'releaseDate',
        page: 'titles',
    }
};

export const legalStatus = {
    field: 'legalStatusId',
    headerName: 'Legal Status',
    flex: 2,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'legalStatusId',
        page: 'titles',
    }
};

export const clearanceMemo = (
    onOpenDeleteModal,
    onOpenCreateModal,
    onOpenEditModal,
    onOpenViewModal,
) => ({
    headerName: 'Clearance Memo',
    valueGetter: (data) => {
        return '';
    },
    cellRenderer: CMActionButtonsRenderer(
        onOpenCreateModal,
        onOpenEditModal,
        onOpenViewModal,
        onOpenDeleteModal,
    ),
    flex: 6,
});

export const memo = {
    headerName: 'Memo',
    valueGetter: (data) => {
        return true;
    },
    cellRenderer: DownloadCellRenderer(true),
    flex: 2,
};

export const report = {
    headerName: 'Report',
    valueGetter: (data) => {
        return false;
    },
    cellRenderer: DownloadCellRenderer(false),
    flex: 2,
};

export const comments = (onOpenCMCommentsModal) => ({
    headerName: 'Comments',
    valueGetter: (data) => {
        return data?.data?.productComments ? data?.data.productComments.length : 0;
    },
    cellRenderer: ClickableCellRenderer(onOpenCMCommentsModal, 'fa-comment'),
    flex: 2,
});

export const centFileNum = (onOpenCentFileModal) => ({
    headerName: 'Cent. File #',
    valueGetter: (data) => {
        return data?.data?.centralFileNumbers ? data?.data.centralFileNumbers.length : 0;
    },
    cellRenderer: ClickableCellRenderer(onOpenCentFileModal, 'fa-file'),
    flex: 2,
});

export const copyright = (
    onOpenCopyrightModal,
) => ({
    headerName: 'Copyright',
    valueGetter: (data) => {
        return data?.data?.copyrightNotices ? data?.data.copyrightNotices.length : 0;
    },
    cellRenderer: ClickableCellRenderer(onOpenCopyrightModal, 'fa-copyright'),
    flex: 2,
});

export const created = {
    headerName: 'Created',
    flex: 2,
    valueGetter: (data) => {
        return data?.data.createdAt && moment(data.data.createdAt).format('MM/DD/YYYY');
    },
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'createdAt',
        page: 'titles',
    }
};
